exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1ITMqGoVbdzRiWz_ZaROip{width:32px;height:32px;line-height:32px}html[dir] ._1ITMqGoVbdzRiWz_ZaROip{border-radius:50%;text-align:center}._26GKG3JyHseGNrPDwhdFNu{color:\"[theme:white, default:#ffffff]\"}", ""]);

// exports
exports.locals = {
	"roomIconContainer": "_1ITMqGoVbdzRiWz_ZaROip",
	"roomIcon": "_26GKG3JyHseGNrPDwhdFNu"
};